import Typography from 'typography';
import { calcLineHeight } from '../utils/helpers';
var baseSpacingUnit = 24;
var baseFontSize = 16;
export var typography = {
  jumbo: 4.2,
  mega: 3.0,
  large: 2.4,
  medium: 1.8,
  small: 1.6,
  tiny: 1.4
};
export var spacing = {
  baseSpacingUnit: baseSpacingUnit,
  baseFontSize: baseFontSize,
  base: baseSpacingUnit,
  halve: baseSpacingUnit / 2,
  quarter: baseSpacingUnit / 4,
  containerWidth: 1000,
  collapseMenuWidth: 840
};
export var color = {
  primaryRed: '#eb3745',
  primaryGreen: '#18a678',
  primaryBlue: '#007aff',
  secondary1: '#213854',
  secondary2: '#354a63',
  secondary3: '#5d6e82',
  secondary4: '#718092',
  secondary5: '#8592a1',
  secondary6: '#c2c8d0',
  secondary7: '#e1e4e8',
  secondary8: '#f0f1f3',
  white: '#fff'
};
var typographyOptions = {
  title: 'Papertrail',
  includeNormalize: true,
  baseFontSize: "10px",
  baseLineHeight: '1.5',
  blockMarginBottom: '2.4rem',
  googleFonts: [{
    name: 'Roboto',
    styles: ['400', '400i', '500']
  }],
  headerWeight: '500',
  boldWeight: '500',
  headerFontFamily: ['Roboto', 'sans-serif'],
  bodyFontFamily: ['Roboto', 'sans-serif'],
  bodyColor: 'rgba(33,56,84,0.7)',
  headerColor: 'rgba(33,56,84,1)',
  overrideStyles: function overrideStyles() {
    return {
      h1: {
        fontSize: typography.jumbo + 'rem',
        lineHeight: calcLineHeight(typography.jumbo)
      },
      h2: {
        fontSize: typography.mega + 'rem',
        lineHeight: calcLineHeight(typography.mega)
      },
      h3: {
        fontSize: typography.large + 'rem',
        lineHeight: calcLineHeight(typography.large)
      },
      h4: {
        fontSize: typography.medium + 'rem',
        lineHeight: calcLineHeight(typography.medium)
      },
      h5: {
        fontSize: typography.small + 'rem',
        lineHeight: calcLineHeight(typography.small)
      },
      h6: {
        fontSize: typography.tiny + 'rem',
        lineHeight: calcLineHeight(typography.tiny)
      }
    };
  }
};
var typographyConfig = new Typography(typographyOptions);
export default typographyConfig;